import { render } from "./Creator.vue?vue&type=template&id=8099925a&ts=true"
import script from "./Creator.vue?vue&type=script&lang=ts"
export * from "./Creator.vue?vue&type=script&lang=ts"

import "./Creator.vue?vue&type=style&index=0&id=8099925a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__